import React from 'react';
import {AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button} from "@chakra-ui/react";


const RequestingPopup = (props) => {

    const cancelRef = React.useRef()

    return (
        <AlertDialog
            isOpen={props?.isOpen}
            leastDestructiveRef={cancelRef}
            onClose={()=>{
                if(props?.onClose) props.onClose();
            }}
        >
            <AlertDialogOverlay isOpen={props?.isOpen}>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        { props?.title || 'Aggiunta di ferma testo (LASCIA VUOTO)'}
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        { props?.msg || 'Il campo di testo è pieno! Desideri ugualmente sostituire?'}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={()=>{if(props?.onDeny) props.onDeny();}}>
                            { props?.denyLabel || `No, lascia tutto com'è!`}
                        </Button>
                        <Button colorScheme='red' onClick={()=>{if(props?.onAccept) props.onAccept();}} ml={3}>
                            {props?.acceptLabel || 'Si, sostituisci!'}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}

export default RequestingPopup;
